var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAlignmentLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4576_70627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3951 0H3.60494C1.61399 0 0 2.10751 0 4.70726V19.2927C0 21.8925 1.61399 24 3.60494 24H36.3951C38.386 24 40 21.8925 40 19.2927V4.70726C40 2.10751 38.386 0 36.3951 0Z",
    fill: "#C9CACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7616 3.68555H6.23887C4.62969 3.68555 3.3252 5.38893 3.3252 7.49017V16.5093C3.3252 18.6106 4.62969 20.314 6.23887 20.314H33.7616C35.3707 20.314 36.6752 18.6106 36.6752 16.5093V7.49017C36.6752 5.38893 35.3707 3.68555 33.7616 3.68555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2277 18.6027H9.0653C7.89366 18.6013 6.77043 18.1617 5.94203 17.3801C5.11362 16.5986 4.64771 15.539 4.64648 14.4339V9.56457C4.64791 8.45956 5.1139 7.40018 5.94229 6.61882C6.77067 5.83746 7.89379 5.39783 9.0653 5.39648H14.2277C15.3992 5.39764 16.5225 5.83724 17.3509 6.61864C18.1793 7.40005 18.6453 8.4595 18.6465 9.56457V14.4339C18.6455 15.5391 18.1796 16.5988 17.3512 17.3803C16.5227 18.1619 15.3994 18.6015 14.2277 18.6027ZM9.0653 6.12396C8.09802 6.12492 7.17065 6.48787 6.48668 7.13302C5.8027 7.77817 5.41801 8.6529 5.41699 9.56528V14.4346C5.4178 15.3471 5.8024 16.2221 6.4864 16.8674C7.17039 17.5127 8.09788 17.8756 9.0653 17.8766H14.2277C15.1951 17.8756 16.1226 17.5127 16.8066 16.8674C17.4905 16.2221 17.8752 15.3471 17.876 14.4346V9.56528C17.875 8.6529 17.4903 7.77817 16.8063 7.13302C16.1223 6.48787 15.195 6.12492 14.2277 6.12396H9.0653Z",
    fill: "#717273"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4576_70627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAlignmentLeft);
export default __webpack_public_path__ + "static/media/active-alignment-left.0210a41c44ba0d64e768880c0816c1f4.svg";
export { ForwardRef as ReactComponent };